import { z } from "zod";
import { authedEndpoint } from "~/lib/api/builder";
import { BasicSettings } from "~/lib/api/schemas/basic-settings";

export const put = authedEndpoint.mutation(
    (data) => ({
        json: data,
        method: "put",
        url: "settings",
    }),
    {
        input: z.object({
            default_locale_id: z.string(),
            timezone: z.string(),
            workflow_type: z.string(),
        }),
        output: BasicSettings,
    },
);
